import { ReactNode } from 'react'
import clsx from 'clsx'

interface PageHeaderProps {
  title: string
  subtitle?: ReactNode
  actions?: ReactNode
  className?: string
}

/**
 * Standard page header used at the top of every dashboard page.
 * Keeps title, subtitle, and primary actions in a consistent grid so
 * spacing/typography stay uniform across the app.
 */
export function PageHeader({ title, subtitle, actions, className }: PageHeaderProps) {
  return (
    <div
      className={clsx(
        'flex flex-col gap-4 lg:flex-row lg:items-start sm:justify-between',
        className,
      )}
    >
      <div className="min-w-0">
        <h1 className="font-outfit text-h1 text-ink break-words tracking-tight">{title}</h1>
        {subtitle && (
          <p className="font-inter text-body-sm text-ink-muted mt-2 max-w-3xl leading-relaxed">{subtitle}</p>
        )}
      </div>
      {actions && (
        <div className="flex flex-wrap items-center gap-2 lg:max-w-[50%] lg:shrink-0 lg:justify-end">{actions}</div>
      )}
    </div>
  )
}

export default PageHeader
